import { render, staticRenderFns } from "./ComplaintForm.vue?vue&type=template&id=7e6b5cc0&scoped=true&"
import script from "./ComplaintForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintForm.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintForm.vue?vue&type=style&index=0&id=7e6b5cc0&lang=scss&scoped=true&"
import style1 from "./ComplaintForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6b5cc0",
  null
  
)

export default component.exports